import { FundingComputedDto } from '../data/types/FundingComputedDto'
import { IFinanceBaseWorksheet } from '../data/types/IFinanceBaseWorksheetSchema'

// Effective coverage amount (no tax) — legacy InsuranceFee when IncludeInsurance is on with a positive
// amount, otherwise the modern ProtectionPlanAmount. Returns 0 when the worksheet has no coverage.
// Mirrors the backend's GetTotalCoverageAmount value-based branching.
export function getCoverageAmount(worksheet: IFinanceBaseWorksheet) {
  if (!worksheet) return 0
  if (hasInsurance(worksheet)) return worksheet.insuranceFee
  return worksheet.protectionPlanAmount ?? 0
}

// True if the customer has coverage via the new Protection flag or the legacy Insurance flag.
export function hasCoverage(worksheet: IFinanceBaseWorksheet) {
  return Boolean(worksheet?.includeProtection || worksheet?.includeInsurance)
}

function hasInsurance(worksheet: IFinanceBaseWorksheet) {
  return worksheet?.includeInsurance && worksheet?.insuranceFee > 0
}

export function computeTotalInsurance(worksheet: IFinanceBaseWorksheet) {
  return getCoverageAmount(worksheet) + (hasInsurance(worksheet) ? worksheet.insuranceTax ?? 0 : 0)
}

// Total coverage amount returned by /Applications/ComputeFunding.
// Mirrors GetTotalCoverageAmount on the backend.
export function computeTotalCoverageFromFunding(funding?: FundingComputedDto): number {
  if (!funding) return 0
  if (funding.insuranceFee > 0) return funding.insuranceFee + (funding.insuranceTax ?? 0)
  return funding.protectionPlanAmount ?? 0
}

export function computeTotalObligation(worksheet: IFinanceBaseWorksheet) {
  return (
    computeTotalInsurance(worksheet) +
    (worksheet?.amountRequested ?? 0) +
    (worksheet?.totalInterestAmount ?? 0) +
    (worksheet?.lenderFee ?? 0)
  )
}
